import { SideMenu } from '../navigation/side-menu';
import { CART_POPUP } from '../classnames/cart-popup';
import { CART_EVENTS } from '../custom-events/cart';

export default class VisibilityHandler {
  sideMenu = new SideMenu();
  menuContainerId = 'cart-popup-container';

  showMenu = () => {
    document.dispatchEvent(new CustomEvent(CART_EVENTS.OPEN), {
      bubbles: true
    });

    this.sideMenu.hideAll();
    this.sideMenu.show(this.menuContainerId);
  };

  closeMenu = () => this.sideMenu.hide(this.menuContainerId);

  initializeEventListeners = () => {
    if (new window.URLSearchParams(window.location.search).get('cart') === 'true') {
      this.showMenu();
    }

    [...document.getElementsByClassName(CART_POPUP)]
      .forEach((element) => element.addEventListener('click', this.showMenu));
  };
}
